import { FileSearchOutlined } from '@ant-design/icons'
import {
  Checkbox,
  Divider,
  Form,
  Input,
  InputNumber,
  Radio,
  Tooltip
} from 'antd'
import React, { useEffect, useState } from 'react'
import InputField from '../common/Input/InputField'
import ModalCustom from '../common/Modal/ModalCustom'
import SelectField from '../common/Select/SelectField'
import {
  APARTMENT_TYPE,
  BALCONY_DIRECTION,
  FURNITURE_TYPE,
  POLICY_DOCUMENT,
  PROCCESS_TRANFER,
  SECURITY_TYPE,
  status,
  statusList
} from './configs'
// import ManagementPost from './ManagePost'
import Note from './Note'
import styles from './styles.module.scss'
import { formatCurrency, formatCurrencyLabel } from '../../config-func'
import ManageRequestDetail from './ManageRequestDetail'
import { listManageRequest } from '../../services/requestservice'
import openNotification from '../common/Notification/openNotification '
import { getListUserDepartment } from '../../services/postservice'

const FormPost = ({
  form,
  // handleSearch,
  listDepartment,
  listUser,
  LabelType,
  ProductType,
  typeRealEstate,
  listRequest,
  cities,
  districts,
  towns,
  postType,
  onChangeProject,
  onChangePostType,
  onChangeCity,
  onChangeDistrict,
  onChangeDepartment,
  mode,
  recordId,
  demandOps,
  typeOfRealEstateOps = [],
  apartmentLocationOptions = [],
  directionOptions = [],
  furnitureOptions,
  procedureOptions,
  legalOptions,
  currentStatusOpstions,
  postStatusOptions,
  postSecurityOptions,
  loading,
  setLoading
}) => {
  const [isModalManagerPost, setIsModalManagerPost] = useState(false)
  const [managers, setManagers] = useState([
    // { id: 2116, name: 'Lê Văn Dương', phone: '0971516193' }
  ])

  const [priceLabel, setPriceLabel] = useState('')

  const getListUserRequest = async (id) => {
    setLoading(true)
    try {
      const res = await listManageRequest(id)
      if (res?.data) {
        setManagers(res?.data?.list)
        const assignerNames = res?.data?.list
          .map((item) => item.assigner_info?.name)
          .filter(Boolean) // Lọc bỏ các giá trị null hoặc undefined
          .join(', ')

        // Set giá trị vào form
        form.setFieldsValue({ assigner_id: assignerNames })
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
    }
  }

  // useEffect(() => {
  //   if (mode !== 'ADD') {
  //     getListUserRequest(form.getFieldValue('id'))
  //   }
  // }, [form.getFieldValue('id')])

  const [managersAdd, setManagersAdd] = useState([])

  const getUserDepartment = async (id) => {
    let page = 1
    let pageSize = 1000

    try {
      const body = {
        page,
        pageSize,
        department_id: id
      }
      const res = await getListUserDepartment(body) // Assuming roleSearch is an API function
      if (res && res.data.list) {
        const result = res?.data?.list.map((item) => ({
          ...item,
          value: item.id,
          label: item.name
        }))
        setManagersAdd(result) // Update the state with the list of roles
      } else {
        // Handle the case where the response is unexpected or empty

        setManagersAdd([]) // Optionally, reset the list to an empty array
      }
    } catch (err) {
      // Handle the error gracefully
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
      // You might want to show a notification or alert to the user here
      setManagersAdd([]) // Optionally, reset the list to an empty array
    }
  }

  useEffect(() => {
    const department_id = localStorage.getItem('department_id')
    if (mode == 'ADD') {
      getUserDepartment(department_id)
    } else {
      getListUserRequest(form.getFieldValue('id'))
    }
  }, [])

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        // onFinish={handleSearch}
        labelAlign="right"
        style={{
          // marginTop: 10,
          overflow: 'auto',
          overflowX: 'hidden',
          padding: '0px 10px'
        }}
        initialValues={{ image_360: [''] }}
      >
        <div className={styles.formAdd}>
          <Form.Item
            label=""
            name="id"
            style={{ display: 'none', marginBottom: 0 }}
          >
            <Input />
          </Form.Item>
          <Divider orientation="left">Thông tin BĐS</Divider>
          <SelectField
            label="Sàn"
            name="department_id"
            required={true}
            options={listDepartment}
            onChange={(e) => {
              onChangeDepartment(e)
              getUserDepartment(e)
            }}
          />
          {/* <SelectField
            label="Quản lý yêu cầu"
            name="assigner_id"
            // required={true}
            options={listUser}
            placeholder="Chọn quản lý yêu cầu"
          /> */}
          {mode == 'ADD' ? (
            <SelectField
              label="Quản lý yêu cầu"
              name="assigner_id"
              mode="multiple"
              options={managersAdd}
              maxTagCount="responsive"
              // onChange={onChangeDepartment}
            />
          ) : (
            <Form.Item
              label={<div>Quản lý yêu cầu </div>}
              name=""
              style={{ marginBottom: 0 }}
              className={styles.formItem}
              // wrapperCol={{ span: 16 }}
            >
              <div
                style={{
                  display: 'flex',
                  gap: '5px',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start'
                }}
              >
                <Form.Item
                  label=""
                  name="assigner_id"
                  style={{ width: '100%' }}
                >
                  <Input style={{ width: '100%', color: '#000' }} disabled />
                </Form.Item>
                <Tooltip title="Thêm quản lý yêu cầu">
                  <FileSearchOutlined
                    onClick={() => {
                      if (mode == 'ADD') return
                      setIsModalManagerPost(true)
                    }}
                    style={{
                      fontSize: '26px',
                      cursor: mode == 'ADD' ? 'not-allowed' : 'pointer',
                      color: '#7a7a7a',
                      marginTop: '3px'
                    }}
                  />
                </Tooltip>
              </div>
            </Form.Item>
          )}
          <SelectField
            label="Nhu cầu"
            name="request_type"
            required={true}
            options={LabelType}
            placeholder="Chọn nhu cầu"
          />
          <SelectField
            label="Loại BĐS"
            name="post_type"
            required={true}
            options={typeOfRealEstateOps}
            onChange={onChangePostType}
          />
          <SelectField
            label="Loại hình BĐS"
            name="type_real_estate"
            required={true}
            options={typeRealEstate}
          />
          {/* <SelectField
            label={`Tên dự án ${
              postType === 2
                ? 'Tòa nhà (Nếu có)'
                : postType === 4
                ? 'Đất nền (Nếu có)'
                : postType === 3
                ? 'Nhà đất (Nếu có)'
                : ''
            }`}
            name="project_id"
            rules={[
              {
                required: postType === 1,
                message: 'Vui lòng chọn dự án'
              }
            ]}
            onChange={(e) => onChangeProject(e)}
            options={listRequest}
          /> */}

          <SelectField
            label="Tỉnh/Thành phố"
            name="city_code"
            required={true}
            onChange={onChangeCity}
            options={cities}
          />
          <SelectField
            label="Quận/Huyện"
            name="district_code"
            required={true}
            onChange={onChangeDistrict}
            options={districts}
          />
          <SelectField
            label={`Phường/Xã`}
            name="town_code"
            required={true}
            options={towns}
          />

          <InputField label="Đường/phố" name="street" form={form} />
          {/* {postType === 1 && (
            <InputField label="Toà/Khu" name="building" form={form} />
          )}
          {postType === 1 && (
            <InputField label="Tầng/Dãy" name="floor" form={form} />
          )}
          {postType === 1 && (
            <InputField label="Số căn" name="number_of_rooms" form={form} />
          )}

          {!(postType === 1) && (
            <InputField label="Sổ địa chỉ" name="alley" form={form} />
          )} */}
          {postType == 1 && (
            <InputField
              label="Số phòng ngủ"
              name="number_of_bedrooms"
              form={form}
            />
          )}
          {(postType == 2 || postType == 3) && (
            <Form.Item
              label="Số tầng"
              name="number_of_floor"
              className={styles.formItem}
            >
              <Input
                placeholder="Nhập số tầng"
                onChange={(e) => {
                  let value = e.target.value

                  // Chuyển dấu "," thành "."
                  value = value.replace(/,/g, '.')

                  // Không cho số 0 đứng đầu nếu sau đó là số khác (không chặn '0' một mình)
                  value = value.replace(/^0+([1-9])/, '$1')

                  // Giữ lại chữ cái, số, dấu . và dấu -
                  value = value.replace(/[^a-zA-Z0-9\.\-]/g, '')

                  form.setFieldsValue({ number_of_floor: value })
                }}
              />
            </Form.Item>
            // <InputField label="Số tầng" name="number_of_floor" form={form} />
          )}
          {postType != 1 && (
            <>
              <Form.Item
                label="Diện tích (m2)"
                name="acreage"
                className={styles.formItem}
              >
                <InputNumber
                  onBlur={(e) => {
                    const value = parseFloat(e.target.value?.trim())
                    form.setFields([
                      {
                        name: 'acreage',
                        value: isNaN(value) ? 0 : value
                      }
                    ])
                  }}
                  className={styles.InputNumber}
                  formatter={(value) =>
                    value ? value.replace(/[^0-9.]/g, '') : ''
                  }
                  parser={(value) => value.replace(/[^0-9.]/g, '.')}
                  placeholder="Nhập diện tích"
                />
              </Form.Item>

              <Form.Item
                label="Mặt tiền (m)"
                name="area_outside"
                className={styles.formItem}
              >
                <InputNumber
                  onBlur={(e) => {
                    const value = parseFloat(e.target.value?.trim())

                    form.setFields([
                      {
                        name: 'area_outside',
                        value: isNaN(value) ? 0 : value
                      }
                    ])
                  }}
                  placeholder="Nhập kích thước"
                  className={styles.InputNumber}
                  formatter={(value) =>
                    value ? value.replace(/[^0-9.]/g, '') : ''
                  }
                  parser={(value) => value.replace(/[^0-9.]/g, '.')}
                />
              </Form.Item>
            </>
          )}

          <SelectField
            label="Vị trí"
            name="apartment_location"
            options={apartmentLocationOptions}
          />
          <SelectField
            label="Hướng"
            name="direction"
            options={directionOptions || []}
          />
          <Form.Item
            label={`Tài chính:  ${formatCurrencyLabel(
              String(form.getFieldValue('price') || '')?.replaceAll('.', '')
            )}`}
            name="price"
            className={styles.formItem}
          >
            <InputNumber
              placeholder="Nhập tài chính"
              onBlur={() => {
                const rawValue = form.getFieldValue('price')
                form.setFields([
                  {
                    name: 'price',
                    value: rawValue // Đảm bảo giá trị luôn đúng kiểu số
                  }
                ])
              }}
              onChange={(value) => {
                setPriceLabel(formatCurrencyLabel(value))
              }}
              className={styles.InputNumber}
              formatter={(value) => {
                if (!value) return ''
                return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
              }}
              parser={(value) => (value ? value.replace(/\./g, '') : '')}
              maxLength={255}
            />
          </Form.Item>
        </div>

        <Form.Item
          label="Mô tả"
          name="description"
          style={{ padding: '0px 8px' }}
        >
          <Input.TextArea
            onBlur={(e) => {
              form.setFields([
                {
                  name: 'description',
                  value: e.target.value?.trim()
                }
              ])
            }}
            placeholder="Nhập nội dung"
            maxLength={255}
          />
        </Form.Item>

        <Divider orientation="left">Thông tin cá nhân</Divider>
        <div className={styles.formAddBottom}>
          <InputField
            label="Họ và tên khách hàng"
            name="customer_full_name"
            form={form}
          />
          <InputField
            label="Số điện thoại"
            name="customer_phone_number"
            form={form}
            rules={[
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve()

                  // Cho phép phân tách bằng dấu , hoặc -
                  const phoneNumbers = value.split(/[,|-]/).map((p) => p.trim())

                  const invalidNumbers = phoneNumbers.filter(
                    (number) => !/^0\d{9}$/.test(number)
                  )

                  if (invalidNumbers.length > 0) {
                    return Promise.reject(
                      new Error(
                        'Mỗi số điện thoại phải có 10 chữ số và bắt đầu bằng 0. Phân tách bằng "," hoặc "-".'
                      )
                    )
                  }

                  return Promise.resolve()
                }
              }
            ]}
          />
        </div>

        <Form.Item
          label="Xác nhận định danh"
          name="identifier_type"
          style={{ padding: '0px 8px' }}
        >
          <Radio.Group
            options={[
              { label: 'Khách hàng', value: 'CUSTOMER' },
              { label: 'Môi giới bất động sản', value: 'AGENCY' }
            ]}
          />
        </Form.Item>
      </Form>
      {mode !== 'ADD' && (
        <Note
          id={form.getFieldValue('id')}
          loading={loading}
          setLoading={setLoading}
        />
      )}
      <ModalCustom
        title="Danh sách quản lý yêu cầu"
        visible={isModalManagerPost}
        centered
        width={600}
        onCancel={() => {
          setIsModalManagerPost(false)
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={''}
      >
        <ManageRequestDetail
          requestId={form.getFieldValue('id')}
          data={listUser}
          list={managers}
          loading={loading}
          setLoading={setLoading}
          getList={getListUserRequest}
        />
      </ModalCustom>
    </>
  )
}

export default FormPost
